import zPage from '../Page/page.vue';
import comRichtext from '@/components/com-richtext.vue';
import {removeRichTextLabel} from '@/assets/js/tools.js';
export default{
    name:'Release',
    components:{
        zPage,
        comRichtext
    },
    data(){
        return{
            currentColumn:'发布中心',
            columnType:1,//1列表2详情
            imgs:[
                // {
                //     path:'home-img1.png',
                //     title:'标题1',
                // },
                // {
                //     path:'home-img2.png',
                //     title:'标题2',
                // },
                // {
                //     path:'home-img3.png',
                //     title:'标题3',
                // },
            ],
            page:{
                targetPage:1,
                pageSize:10,
                totalPage:100,
                type:2,
            },
            sffb:[],
            jsfb:[],
            zbfb:[],
            releaseList:[],
            releaseDetail:{},
            //发布详情标题list
            detailTitle:[],
            //示范发布
            sffbDetailTitle:[
                {
                    title:'项目目标',
                    key:'xmmb',
                },
                {
                    title:'技术路线',
                    key:'jslx',
                },
                {
                    title:'研究任务',
                    key:'yjrw',
                },
                {
                    title:'发布内容',
                    key:'fbnr',
                }
            ],
            //装备发布
            zbfbDetailTitle:[
                {
                    title:'装备创新点',
                    key:'zbcxd',
                },
                {
                    title:'研发团队',
                    key:'yftd',
                },
                {
                    title:'研究期限',
                    key:'yjqx',
                },
                {
                    title:'发布内容',
                    key:'fbnr',
                }
            ],
            //技术发布
            jsfbDetailTitle:[
                {
                    title:'项目目标',
                    key:'jscxnr',
                },
                {
                    title:'技术路线',
                    key:'jslx',
                },
                {
                    title:'研发团队',
                    key:'jstd',
                },
                {
                    title:'技术研究任务',
                    key:'jsyjrw',
                },
                {
                    title:'发布内容',
                    key:'fbnr',
                }
            ],
        }
    },
    created(){
        this.getData();
    },
    methods:{
        changeColumn(name){
            this.columnType=1;
            this.currentColumn=name;
            this.page={
                targetPage:1,
                pageSize:10,
                totalPage:100,
                type:2,
            };
            if(name=='发布中心'){
                this.getData();
            }else{
                this.getReleaseList(name);
            }
            

        },
        getDetail(type,id){
            this.columnType=2;
            var url='';
            type=type?type:this.currentColumn;
            switch(type){
                case '示范发布':
                    url=this.api.getSffbById;
                    this.detailTitle=this.sffbDetailTitle;
                break;
                case '装备发布':
                    url=this.api.getZbfbById;
                    this.detailTitle=this.zbfbDetailTitle;
                break;
                case '技术发布':
                    url=this.api.getJsfbById;
                    this.detailTitle=this.jsfbDetailTitle;
                break;
            }
            this.get(url,{id,id}).then(res=>{
                this.releaseDetail=res.data;
                if(type=='装备发布'){
                    this.releaseDetail.yjnr=this.releaseDetail.yt;
                }
                if(type=='技术发布'){
                    this.releaseDetail.yjnr=this.releaseDetail.jsnr;
                }
                window.scrollTo(0,0);
            }).catch();
        },
        getData(){
            this.get(this.api.getFbzxPage).then(res=>{
                if(res.result==200){
                    this.sffb=res.data.sffb.list;
                    for(var i=0; i<this.sffb.length;i++){
                        
                        this.sffb[i].modifyDate=this.sffb[i].modifyDate.substring(0,10);
                        this.imgs.push({path:this.sffb[i].sctp,title:this.sffb[i].infoTitle,id:this.sffb[i].id});
                    }
                    this.zbfb=res.data.zbfb.list;
                    for(var i=0; i<this.zbfb.length;i++){
                        this.zbfb[i].modifyDate=this.zbfb[i].modifyDate.substring(0,10);
                    }
                    this.jsfb=res.data.jsfb.list;
                    for(var i=0; i<this.jsfb.length;i++){
                        this.jsfb[i].modifyDate=this.jsfb[i].modifyDate.substring(0,10);
                        this.jsfb[i].abstratc=removeRichTextLabel(this.jsfb[i].fbnr);
                    }
                }
            }).catch();
        },
        getReleaseList(type){
            var url='';
            switch(type){
                case '示范发布':
                    url=this.api.getSffbPage;
                break;
                case '装备发布':
                    url=this.api.getZbfbPage;
                break;
                case '技术发布':
                    url=this.api.getJsfbPage;
                break;
            }
            var body={
                pageNumber:this.page.targetPage-1,
                pageSize:this.page.pageSize
            };
            this.get(url,body).then(res=>{
                this.releaseList=res.data.list;
                this.page.totalPage=res.data.totalElements;
                for(var i =0;i<this.releaseList.length;i++){
                    this.releaseList[i].modifyDate=this.releaseList[i].modifyDate.substring(0,10);
                    this.releaseList[i].abstratc=removeRichTextLabel(this.releaseList[i].fbnr);
                }
            }).catch();
        },
        changePage1 (val, type) {
            if (type) {
                this.page.targetPage = 1;
                this.page.pageSize = val;
            } else {
                this.page.targetPage = val;
            }
            this.getReleaseList(this.currentColumn);
        },
    }
}